<script>
    import { onMount, onDestroy, createEventDispatcher } from 'svelte';
    import { get, writable } from 'svelte/store';
    import  Gantt from 'frappe-gantt';
    import Button from "../../components/Button.svelte";
    import Icon from "../../components/Icon.svelte";
    import moment from "moment";
    //const Gantt = require('frappe-gantt');
  
    /**
     *  PROPS
     */
    export let tasks = [];
    export let header_height= 50;
    export let column_width= 30;
    export let step= 24;
    export let view_modes= ['Day', 'Week', 'Month'];
    export let bar_height= 20;
    export let bar_corner_radius= 3;
    export let arrow_curve= 5;
    export let padding= 18;
    export let view_mode= 'Week';
    export let date_format= 'DD/MM/YYYY';
    export let language= 'en'; // or 'es', 'it', 'ru', 'ptBr', 'fr', 'tr', 'zh', 'de', 'hu'
    export let custom_popup_html= null;

    let timefilter = 'Week';

    const dispatch = createEventDispatcher();
    /**
     *  COMPONENT
     */
    //  The Chart returned from frappe
    let chart = null;
    //  DOM node for frappe to latch onto
    let chartRef;
  
    //  Helper HOF for calling a fn only if chart exists
    function ifChartThen(fn) {
      return function ifChart(...args) {
        if (chart) {
          return fn(...args);
        }
      }
    }
  
    /**
     * Methods for updating / exporting the chart
     */
    //  Allow the consumer to change view mode
    export const change_view_mode = ifChartThen((mode) => {
      chart.change_view_mode(mode);
    });
  
    //  Update the chart when incoming data changes
    const refresh = ifChartThen((newTasks) => chart.refresh(newTasks));
    $: refresh(tasks);
    
    if (!custom_popup_html){
      custom_popup_html = function(task) {
          // the task object will contain the updated
          // dates and progress value
          const end_date = task._end ==null?'':moment(task._end).format('D MMMM ');
          const start_date = task._start ==null?'':moment(task._start).format('D MMMM');
          return `
          <div class="details-container" style="padding:10px;">
            <h5>${task.name}</h5>
            <br />
            <p>Data inizio: ${start_date}</p>
            <p>Data fine: ${end_date}</p>
            <p>Completato: ${task.progress}%</p>
          </div>
          `;
        };
    }

  
    /**
     *  Handle initializing the chart when this Svelte component mounts
     */
    onMount(() => {
      chart = new Gantt(chartRef, tasks, {
            header_height: header_height,
            column_width: column_width,
            step: step,
            view_modes: view_modes,
            bar_height: bar_height,
            bar_corner_radius: bar_corner_radius,
            arrow_curve: arrow_curve,
            padding: padding,
            view_mode: view_mode,
            date_format: date_format,
            language: language,
            custom_popup_html: custom_popup_html,
            on_click: function (task) {
                console.log(task);
                dispatch('click',task);
            },
            on_date_change: function(task, start, end) {
                console.log(task, start, end);
                dispatch('date_change',task, start, end);
            },
            on_progress_change: function(task, progress) {
                console.log(task, progress);
                dispatch('progress_change',task, progress);
            },
            on_view_change: function(mode) {
                console.log(mode);
                dispatch('view_change',mode);
            }
        });
    });
  
    //  Mark Chart references for garbage collection when component is unmounted
    onDestroy(() => {
      chart = null;
    });
  </script>
  
  <div class="buttons has-addons" role="group"> 
	  <Button on:click={() => {chart.change_view_mode('Day');timefilter = 'Day'}} klass={timefilter=='Day'?'is-info is-selected':''}>
     
      <span> Giorno </span>
    </Button>
    <Button on:click={() => {chart.change_view_mode('Week');timefilter = 'Week'}}   klass={timefilter=='Week'?'is-info is-selected':''} >
     
      <span> Settimana </span>
    </Button>
    <Button on:click={() => {chart.change_view_mode('Month');timefilter = 'Month'}}  klass={timefilter=='Month'?'is-info is-selected':''}>
     
      <span> Mese </span>
    </Button>
	</div>
  <div
    bind:this={chartRef} 
  ></div>




<style>
  :global .gantt-container {
    HEIGHT: calc(100vh - 50em);
    width: 100%;
    box-sizing: BORDER-BOX;

    position: relative;
    overflow: auto;
    font-size: 12px; }


</style>
